import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MultiSelectComponent} from "ng-multiselect-dropdown";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-shared-multiselect',
  templateUrl: './shared-multiselect.component.html',
  styleUrls: ['./shared-multiselect.component.scss']
})
export class SharedMultiselectComponent implements OnInit {

  @ViewChild('checkbox' , {static: false})
  public mulObj: MultiSelectComponent;
  public mode: string;
  @Input()public filterPlaceholder: string;
  // map the groupBy field with category column
  //public checkFields = { text: 'country', value: 'country' };
  @Input()public checkFields: any;
  // set the placeholder to the MultiSelect input
  @Input()public checkWaterMark;
  // set the MultiSelect popup height
  public popHeight = '350px';
  @Input()public data: any;
  @Input()multiCheckBoxId: string;
  @Output()selectCallBack = new EventEmitter();
  @Output()removeCallBack = new EventEmitter();
  @Input()type: string;
  @Input() selectedText: any;
  multiSelectFormGroup: FormGroup;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    
    this.mode = 'CheckBox';
    this.checkFields = JSON.parse(this.checkFields);
    this.createMultiselectForm();
  }

  createMultiselectForm() {
    this.multiSelectFormGroup = this.formBuilder.group({
      multiSelectData: ['' , Validators.required]
    })
  }

  get f () {
    return this.multiSelectFormGroup.controls;
  }

  selectEvent($event: any) {
     this.selectCallBack.emit({emittedVal: $event, emittedType: this.type})
  }

  removeEvent($event: any) {
    this.selectCallBack.emit({emittedVal: $event, emittedType: this.type})
  }

}
